import axios from 'axios';

export const ftpFeedListApi = async (queryString, config) => {
    return await axios.get(`${process.env.REACT_APP_KUSHDIAMOND_URL_API}/api/ftp_product/list/?` + queryString, config);
};

export const sendClientFtpFeedApi = async (reqData, config) => {
    return await axios.post(`${process.env.REACT_APP_KUSHDIAMOND_URL_API}/api/send_feed/`, reqData, config);
};
